import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CloseSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/CloseSquareTwoTone";
import AntdIcon from "../components/AntdIcon";
var CloseSquareTwoTone = function CloseSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloseSquareTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CloseSquareTwoTone.displayName = 'CloseSquareTwoTone';
}
export default /*#__PURE__*/React.forwardRef(CloseSquareTwoTone);